import { useEffect, useState } from 'react';
import { AvisoRegras, duracaoDoRealce, nomeDoRealce, Realce, type RealceFaixa } from '../avisos/regras';
import { t } from '../i18n/idioma';
import { Icone } from './kit';

export interface AvisoNaTela {
  readonly id: number;
  readonly realce: RealceFaixa;
  readonly rotulo: string;
  readonly texto: string;
  readonly icone: string;
  /** Aviso de evento: cor própria, sai sozinho e não tem botão de fechar. */
  readonly evento: boolean;
}

interface Props {
  atual: AvisoNaTela | null;
  onFechar(): void;
}

export function AvisoFaixa({ atual, onFechar }: Props) {
  const [resta, setResta] = useState(0);

  useEffect(() => {
    if (!atual) return;
    if (atual.realce === Realce.Urgente && !atual.evento) {
      setResta(0);
      return;
    }
    const fim = Date.now() + (atual.evento ? AvisoRegras.duracaoMs.evento : duracaoDoRealce(atual.realce));
    let fechou = false;
    const tick = () => {
      const s = Math.max(0, Math.ceil((fim - Date.now()) / 1000));
      setResta(s);
      if (s <= 0 && !fechou) {
        fechou = true;
        onFechar();
      }
    };
    tick();
    const id = window.setInterval(tick, 200);
    return () => window.clearInterval(id);
  }, [atual, onFechar]);

  if (!atual) return null;
  const tom = atual.evento ? 'evento' : nomeDoRealce(atual.realce);
  const urgente = atual.realce === Realce.Urgente;
  const fechaSozinha = !urgente || atual.evento;

  return (
    <div
      key={atual.id}
      className={`aviso-faixa aviso-faixa--${tom}`}
      role="status"
      aria-live={urgente ? 'assertive' : 'polite'}
      style={atual.evento ? { ['--aviso-dur' as string]: `${AvisoRegras.duracaoMs.evento}ms` } : undefined}
    >
      <span className="aviso-faixa__ico">
        <Icone nome={atual.icone} tam={22} />
      </span>
      <span className="aviso-faixa__txt">
        <span className="aviso-faixa__rot">
          {atual.rotulo}
          {fechaSozinha && resta > 0 && (
            <span className="aviso-faixa__seg">{t('aviso.resta', { n: resta })}</span>
          )}
        </span>
        <span className="aviso-faixa__msg">{atual.texto}</span>
      </span>
      {atual.evento
        ? <span className="aviso-faixa__barra" aria-hidden="true" />
        : (
          <button
            type="button"
            className="aviso-faixa__x"
            aria-label={t('comum.fechar')}
            onClick={onFechar}
          >
            ×
          </button>
        )}
    </div>
  );
}
